import { SAVINGS_PLAN_SUBSCRIPTION_REMOVE_COTIZACION } from '../constants'

export function removeCotizacion(auto) {
    return {
        type: SAVINGS_PLAN_SUBSCRIPTION_REMOVE_COTIZACION,
        data: auto
    }
}

export function reducer(state, action) {
    if (action.type === SAVINGS_PLAN_SUBSCRIPTION_REMOVE_COTIZACION) {
        return {
            ...state,
            entregaUsados: state.entregaUsados?.filter(usado => usado.quotation_id !== action.data.quotation_id),
            quotes: state.quotes?.filter(item => item.quote_id !== action.data.quotation_id)
        }
    } else {
        return state
    }
}
